

const Constants = {
    // API_URL: "https://localhost:44344/"
    API_URL: "https://api.ferual.com/"
}

export default Constants;